{
  "version": 1,
  "asset_id": "56bc223f-7b78-4673-9354-b8b5ca695350",
  "project_id": "821317bb-5c16-42f2-91c7-33504f8f052a",
  "url": "/__l5e/assets-v1/56bc223f-7b78-4673-9354-b8b5ca695350/plan-basic.png",
  "r2_key": "a/v1/821317bb-5c16-42f2-91c7-33504f8f052a/56bc223f-7b78-4673-9354-b8b5ca695350/plan-basic.png",
  "original_filename": "plan-basic.png",
  "size": 132915,
  "content_type": "image/png",
  "created_at": "2026-06-26T13:31:05Z"
}
